<template>
  <el-dialog
    :title="title"
    :visible="dialogFormVisible"
    :before-close="handleClose"
    width="60%"
    class="investor_dialog"
  >
    <table-form
      :dataSource="dataSource"
      ref="form"
      :tableData="formData"
      :disable="disabled"
      @inputChange="inputChange"
      :key="formkey"
    ></table-form>
    <div class="upload">
      <el-table :data="dataUp" style="width: 100%" border>
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column prop="title" label="材料名称" width="150"></el-table-column>
        <el-table-column prop="oldFile" label="附件名称" width="auto"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <a href="javascript:void(0);" class="input">
              上传
              <input
                :key="dialogFormVisible"
                type="file"
                class="file"
                @change="getFile($event, scope)"
                accept="application/pdf,image/*,application/x-zip-compressed,application/x-rar-compressed"
              />
            </a>
          </template>
        </el-table-column>
        <el-table-column label="下载附件" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="scope.row.newFile ? false : true"
              @click="downFile(scope.row)"
              style="font-size: 14px"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" class="pull-left" @click="allDisabled">编辑</el-button>
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from 'common/components/form/tableForm'
import { step2 } from '@/conf/newAgency'
import { AgencyStep2 } from '@/conf/Agency'
import {
  // upload,
  selectDic,
  addInvestor,
  addUpInvestor,
  getInvestorDetail,
  singleUpload,
  institutionDownLoadCommon
} from 'common/js/api'
export default {
  components: {
    TableForm
  },

  props: ['dialogVisible', 'title', 'codeId', 'detailId', 'totalCapture', 'currentCapturePercent'],

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      disabled: true,
      formData: {},
      fundType: '',
      formkey: 0,
      dataUp: [
        {
          title: '出资人登记承诺书（已登记无须提供）',
          oldFile: '--',
          newFile: ''
        },
        {
          title: '学位/学历材料（仅自然人提供）',
          oldFile: '--',
          newFile: ''
        },
        {
          title: '出资能力佐证材料',
          oldFile: '--',
          newFile: ''
        },
        {
          title: '营业执照/身份证',
          oldFile: '--',
          newFile: ''
        },
        {
          title: '简介',
          oldFile: '--',
          newFile: ''
        }
      ],
      upIndex: 0,
      selectedBasicFtCode: ''
    }
  },

  mounted() {
    this.selectedBasicFtCode = this.Cookies.get('selectedBasicFtCode')
    this.getSelect()
    if (this.$route.path == '/FundManagement/NewAgency') {
      this.dataSource = this.$lodash.cloneDeep(step2)
    } else {
      this.fundType = this.Cookies.get('fundType')
      console.log(this.fundType)
      console.log('this.fundType')
      if (this.fundType == '持股平台') {
        this.dataUp = [
          {
            title: '营业执照/身份证',
            oldFile: '--',
            newFile: ''
          }
        ]
      } else if (this.fundType == '自有资金投资类企业') {
        this.dataUp = [
          {
            title: '承诺出资额佐证材料',
            oldFile: '--',
            newFile: ''
          },
          {
            title: '认缴出资能力佐证材料',
            oldFile: '--',
            newFile: ''
          },
          {
            title: '已缴出资额佐证材料',
            oldFile: '--',
            newFile: ''
          },
          {
            title: '出资人备案承诺书',
            oldFile: '--',
            newFile: ''
          }
        ]
      } else {
        this.dataUp = [
          {
            title: '营业执照/身份证',
            oldFile: '--',
            newFile: ''
          },
          {
            title: '合格投资者佐证材料',
            oldFile: '--',
            newFile: ''
          },
          {
            title: '资本认缴承诺函',
            oldFile: '--',
            newFile: ''
          }
        ]
      }
      console.log(this.fundType)
      console.log('this.fundType')
      // this.dataUp:

      // this.dataUp.push({
      //     title: "营业执照/身份证",
      //     oldFile: "--",
      //     newFile: "",
      //   });
      //   {
      //   title: "合格投资者证明",
      //   oldFile: "--",
      //   newFile: "",
      // });
      this.dataSource = this.$lodash.cloneDeep(AgencyStep2)
    }
  },

  methods: {
    inputChange(val) {
      //变更直接修改百分比
      if (val.key === 'capture') {
        this.$refs.form.form.capturePercent = (
          ((parseFloat(val.value) * 10000) / (parseFloat(this.totalCapture) * 10000)) *
          100
        ).toFixed(2)
      }
    },
    allDisabled() {
      this.disabled = false
      if (this.disabled == false) {
        this.$message({
          message: '已开启编辑模式',
          type: 'success'
        })
      }
    },
    async downFile(row) {
      // const fileData = row.newFile.split("/");
      // const suffix = row.newFile.split(".");
      const filePath = row.newFile
      const fileName = row.oldFile
      console.log('@@row', row)
      console.log('@@filePath', filePath)
      console.log('@@fileName', fileName)
      const params = {
        filePath: filePath,
        fileName: fileName
      }

      console.log(params)
      await institutionDownLoadCommon(params)

      // await downLoadCommon(fileData[0], suffix[1], row.oldFile, suffix[0]);
    },

    async getSelect() {
      const query = '3'
      // const query = "3,10";
      const result = await selectDic(query)
      const { INVESTOR_CHARACTER, INVESTOR_TYPE } = result.result
      this.converSelect(INVESTOR_CHARACTER, 1)
      // this.converSelect(INVESTOR_TYPE, 5);
    },

    converSelect(option, index) {
      option.forEach(item => {
        let data = {
          label: item,
          value: item
        }
        this.dataSource[index].options.push(data)
      })
    },

    handleClose() {
      this.resetForm()
      this.dialogFormVisible = false
      this.$emit('closeDialog')
    },

    getFile(event, scope) {
      this.upIndex = scope.$index
      let file = event.target.files[0]
      let fileName = file.name
      if (file.size > 80 * 1024 * 1024) {
        this.$message({
          message: '上传的文件不能大于80M',
          type: 'warning'
        })
        this.file = ''
      } else {
        if (file) {
          let idx = fileName.lastIndexOf('.')
          if (idx != -1) {
            let ext = fileName.substr(idx + 1).toUpperCase()
            ext = ext.toLowerCase()
            if (
              // ext != "bmp" &&
              // ext != "jpg" &&
              // ext != "png" &&
              // ext != "jpeg" &&
              // ext != "gif" &&
              // ext != "webp" &&
              // ext != "svg" &&
              // ext != "tiff" &&
              // ext != "pjp" &&
              // ext != "jfif" &&
              // ext != "xbm" &&
              // ext != "dib" &&
              // ext != "jxl" &&
              // ext != "svgz" &&
              // ext != "tif" &&
              // ext != "pjpeg" &&
              // ext != "avif" &&
              ext != 'pdf' &&
              ext != 'rar' &&
              ext != 'zip'
            ) {
              this.$message.error('请上传格式正确的文件，支持pdf、rar和zip')
            } else {
              this.file = file
              this.oldFile = fileName

              this.$message({
                type: 'warning',
                message: '文件开始上传'
              })

              this.uploadForm(event)
            }
          }
        }
      }
    },

    async uploadForm(event) {
      event.preventDefault()
      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('ftCode', this.selectedBasicFtCode)
      formData.append('institutionName', this.Cookies.get('institutionName'))

      let loadingInstance = this.$loading({ fullscreen: true })
      let a = setTimeout(() => {
        loadingInstance.close()
      }, 120000)
      const result = await singleUpload(formData)
      clearTimeout(a)
      loadingInstance.close()
      console.log(result)
      console.log('~~~~~~result~~~~')
      this.dataUp[this.upIndex].oldFile = result.result.orignName
      this.dataUp[this.upIndex].newFile = result.result.storePath

      this.$message({
        message: '上传成功',
        type: 'success'
      })
    },

    async submit() {
      const isValidate = this.$refs.form.submitForm()
      if (!isValidate) return false
      let form = this.$refs.form.form
      form['institutionCode'] = this.codeId
      // // 业务规范承诺书;
      // form.bussinessPermissionOrignName = this.dataUp[2].oldFile;
      // form.bussinessPermissionStorePath = this.dataUp[2].newFile;
      // //资本认缴承诺书
      // form.captalPaidOrignName = this.dataUp[1].oldFile;
      // form.captalPaidStorePath = this.dataUp[1].newFile;

      console.log(this.$route.path)
      console.log('~~~~~route.path~~~~~')

      if (this.$route.path == '/FundAgency/Agency') {
        if (this.fundType == '持股平台') {
          // 营业执照
          form.investorIdentityFileOrginName = this.dataUp[0].oldFile
          form.investorIdentityFileStorePath = this.dataUp[0].newFile
        } else if (this.fundType == '自有资金投资类企业') {
          // 承诺出资额佐证材料
          form.admitCapitalFileOrginName = this.dataUp[0].oldFile
          form.admitCapitalFileStorePath = this.dataUp[0].newFile
          //认缴出资能力佐证材料
          form.qualifiedInvestorFileOrignName = this.dataUp[1].oldFile
          form.qualifiedInvestorFileStorePath = this.dataUp[1].newFile
          // 已缴出资额佐证材料
          form.paidCapitalFileOrginName = this.dataUp[2].oldFile
          form.paidCapitalFileStorePath = this.dataUp[2].newFile
          // 出资人备案承诺书
          form.investorPromiseOrginName = this.dataUp[3].oldFile
          form.investorPromiseStorePath = this.dataUp[3].newFile
        } else {
          // 营业执照
          form.identityFileOrignName = this.dataUp[0].oldFile
          form.identityFileStorePath = this.dataUp[0].newFile
          // 出资能力佐证材料
          form.qualifiedInvestorFileOrignName = this.dataUp[1].oldFile
          form.qualifiedInvestorFileStorePath = this.dataUp[1].newFile
          // 出资人登记承诺书
          form.promiseOrignName = this.dataUp[2].oldFile
          form.promiseStorePath = this.dataUp[2].newFile
        }
      } else {
        // 出资人登记承诺书
        form.promiseOrignName = this.dataUp[0].oldFile
        form.promiseStorePath = this.dataUp[0].newFile
        // 学位/学历材料
        form.degreeOrignName = this.dataUp[1].oldFile
        form.degreeStorePath = this.dataUp[1].newFile
        // 出资能力佐证材料
        form.qualifiedInvestorFileOrignName = this.dataUp[2].oldFile
        form.qualifiedInvestorFileStorePath = this.dataUp[2].newFile
        // 营业执照
        form.identityFileOrignName = this.dataUp[3].oldFile
        form.identityFileStorePath = this.dataUp[3].newFile
        //简介
        form.qualifiedEvidOrignName = this.dataUp[4].oldFile
        form.qualifiedEvidStorePath = this.dataUp[4].newFile
      }
      // code id
      form.institutionCode = this.codeId
      console.log(form.institutionCode)
      if (this.title.includes('编辑')) {
        form.id = this.detailId
      } else {
        form.id = 0
      }
      console.log(form)
      console.log('form')

      await addUpInvestor(this.title, form)
      const message = this.title.includes('添加') ? '添加' : '编辑'
      this.$message({
        message: `出资人${message}成功!`,
        type: 'success'
      })
      this.handleClose()
    },

    // 点击编辑获取详情
    async editGeiDetail(id) {
      const res = await getInvestorDetail(id)

      console.log('investor组件--editGeiDetail(id)--根据id查询出资人信息')
      this.formData = res.result
      if (this.formData.qualified == 1) {
        this.formData.qualified = '1'
      }
      if (this.formData.qualified == 0) {
        this.formData.qualified = '0'
      }
      this.$set(this.formData, 'capturePercent', this.currentCapturePercent)
      if (this.$route.path == '/FundManagement/NewAgency') {
        this.dataUp[0].oldFile = this.formData.promiseOrignName
        this.dataUp[0].newFile = this.formData.promiseStorePath
        this.dataUp[1].oldFile = this.formData.degreeOrignName
        this.dataUp[1].newFile = this.formData.degreeStorePath
        this.dataUp[2].oldFile = this.formData.qualifiedInvestorFileOrignName
        this.dataUp[2].newFile = this.formData.qualifiedInvestorFileStorePath
        this.dataUp[3].oldFile = this.formData.identityFileOrignName
        this.dataUp[3].newFile = this.formData.identityFileStorePath
        this.dataUp[4].oldFile = this.formData.qualifiedEvidOrignName
        this.dataUp[4].newFile = this.formData.qualifiedEvidStorePath
      } else {
        if (this.fundType == '持股平台') {
          // 营业执照
          this.dataUp[0].oldFile = this.formData.identityFileOrignName
          this.dataUp[0].newFile = this.formData.identityFileStorePath
        } else if (this.fundType == '自有资金投资类企业') {
          // 承诺出资额佐证材料
          this.dataUp[0].oldFile = this.formData.admitCapitalFileOrginName
          this.dataUp[0].newFile = this.formData.admitCapitalFileStorePath
          //自有资金投资类企业
          this.dataUp[1].oldFile = this.formData.qualifiedInvestorFileOrignName
          this.dataUp[1].newFile = this.formData.qualifiedInvestorFileOrignName
          // 已缴出资额佐证材料
          this.dataUp[2].oldFile = this.formData.paidCapitalFileOrginName
          this.dataUp[2].newFile = this.formData.paidCapitalFileOrginName
          // 出资人备案承诺书
          this.dataUp[3].oldFile = this.formData.investorPromiseOrginName
          this.dataUp[3].newFile = this.formData.investorPromiseStorePath
        } else {
          // 营业执照
          this.dataUp[0].oldFile = this.formData.identityFileOrignName
          this.dataUp[0].newFile = this.formData.identityFileStorePath
          // 出资能力佐证材料
          this.dataUp[1].oldFile = this.formData.qualifiedInvestorFileOrignName
          this.dataUp[1].newFile = this.formData.qualifiedInvestorFileStorePath
          // 出资人登记承诺书
          this.dataUp[2].oldFile = this.formData.promiseOrignName
          this.dataUp[2].newFile = this.formData.promiseStorePath
        }
      }
    },

    resetForm() {
      this.formData = {}
      this.formkey++
      this.dataUp.forEach(item => {
        item.oldFile = ''
        item.newFile = ''
      })
    }
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue
      if (newValue && this.title.includes('编辑')) {
        this.editGeiDetail(this.detailId)
        this.disabled = true
      }
      if (this.title.includes('添加')) {
        this.disabled = false
      }
    }

    // tableData: {
    //   handler(newValue) {
    //     console.log("TCL: handler -> newValue", newValue);
    //     this.formData = newValue;
    //   },
    //   deep: true
    // }
  }
}
</script>

<style scoped>
.upload {
  padding-top: 30px;
}

/*input*/
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  width: 70px;
  /* border-radius: 5px; */
  height: 30px;
  margin-top: 1px;
  vertical-align: top;
  line-height: 28px;
  /* background: #409EFF; */
  /* background: #3091d1; */
  text-align: center;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: bottom;
  text-align: left;
}

/* a.input:hover {
  background: #66b1ff;
  color: #ffffff;
} */

a {
  text-decoration: none;
  color: #3165ff;
  position: absolute !important;
  left: 10px;
  top: 10px;
  font-size: 13px;
}

.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
}
</style>
